<template>
  <section class="py-12 text-center lg:py-24" :style="{ backgroundColor: bgColor }">
    <div class="px-4 mx-auto max-w-3xl md:px-6">
      <h3 class="text-2xl text-center xl:leading-10 font-ww-bold xl:text-42 md:text-3xl xl:px-8"
          :style="{ color: headingColor }"
          v-html="heading">
      </h3>
      <div class="mt-4 text-base italic md:mt-7 md:text-lg xl:text-xl"
           :style="{ color: quoteColor }"
           v-html="quote">
      </div>
      <div class="mt-6 text-base font-ww-medium md:text-lg xl:text-xl"
           v-html="author">
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const props = defineProps({
  bgColor: {
    type: String,
    default: '#F9F5ED'
  },
  heading: {
    type: String,
    default: 'Why Customers Love Mindflow'
  },
  headingColor: {
    type: String,
    default: '#000000'
  },
  quote: {
    type: String,
    default: '"With Mindflow, I don\'t just get energy—I get focus. No jitters, no crash. Just hours of locked-in productivity."'
  },
  quoteColor: {
    type: String,
    default: '#000000'
  },
  author: {
    type: String,
    default: '— [Name], Verified Customer'
  },
  authorColor: {
    type: String,
    default: '#404040'
  }
})

defineBuilderComponent({
  friendlyName: 'Single Testimonial',
  inputs: [
    {
      name: 'bgColor',
      type: 'color',
      defaultValue: '#F9F5ED'
    },
    {
      name: 'heading',
      type: 'richText',
      defaultValue: 'Why Customers Love Mindflow'
    },
    {
      name: 'headingColor',
      type: 'color',
      defaultValue: '#000000'
    },
    {
      name: 'quote',
      type: 'richText',
      defaultValue: '"With Mindflow, I don\'t just get energy—I get focus. No jitters, no crash. Just hours of locked-in productivity."'
    },
    {
      name: 'quoteColor',
      type: 'color',
      defaultValue: '#000000'
    },
    {
      name: 'author',
      type: 'richText',
      defaultValue: '— [Name], Verified Customer'
    },
    {
      name: 'authorColor',
      type: 'color',
      defaultValue: '#404040'
    }
  ]
})
</script>
